import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center">
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#E5383B]">Error 404</p>
        <h1 className="mt-4 text-5xl sm:text-6xl font-[Outfit] font-bold text-[#14241F]">Page not found.</h1>
        <p className="mt-4 text-[#495D56] text-lg">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" data-testid="notfound-home-btn" className="mt-8 inline-flex items-center justify-center bg-[#1A3A32] text-white hover:bg-[#14241F] rounded-lg px-6 py-3 font-semibold">
          Back to home
        </Link>
      </div>
    </div>
  );
}
